module.exports = __webpack_public_path__ + "img/blackboardlight.01767919.png";